import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import RefundPolicy from "./pages/RefundPolicy";
import { Toaster } from "sonner";
import { LanguageProvider } from "./lib/i18n";
import CookieBanner from "./components/CookieBanner";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/refund" element={<RefundPolicy />} />
          </Routes>
        </BrowserRouter>
        <CookieBanner />
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              background: "#1A1A1A",
              color: "#F8F5F2",
              border: "1px solid #6E1A24",
              borderRadius: 0,
              fontFamily: "Manrope, sans-serif",
            },
          }}
        />
      </LanguageProvider>
    </div>
  );
}

export default App;
